module.exports = __webpack_public_path__ + "static/img/地球守护.dfdd2b6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/地球守护.gif
// module id = JmyC
// module chunks = 3